import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: '100%',
    minHeight: theme.spacing(6),
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${theme.spacing(2)}px`,
    textAlign: 'left',

    '& .title': {
      flexGrow: 1,
    },
    '& .icon': {
      marginTop: 2,
      display: 'flex',
    },

    '&:hover': {
      backgroundColor: theme.palette.custom.surface[1],
    },

    '&.active': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.custom.surface[1],
      '& .title-text': {
        fontWeight: theme.typography.fontWeightBold,
      },
    },
  },
}));

export default styles;
